import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  containerChoice: {
    width: 109,
    borderRadius: 10,
    overflow: 'hidden',
    borderWidth: 2,
    borderColor: 'transparent',
  },
  containerChoiceInner: {
    flexDirection: 'column',
  },
  containerChoiceActive: {
    borderColor: brand.main.water,
  },
  containerChoiceFocus: {
    borderColor: FOCUS_COLOR,
  },
  choiceImage: {
    width: '100%',
    height: 91,
    borderRadius: 8,
  },
  choiceDetails: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    paddingVertical: 4,
  },
  choiceText: {
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 16,
    color: neutrals.neutralGrays.graphite,
    fontWeight: 400,
  },
  choiceTextActive: {
    color: brand.main.water,
  },
  choicePrice: {
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
    fontSize: 16,
    lineHeight: 20,
  },
  choicePriceActive: {
    fontWeight: 700,
    color: brand.main.water,
    marginBottom: 0,
  },
  subTag: {
    backgroundColor: brand.main.mustard,
    paddingHorizontal: 6,
    paddingVertical: 3,
    gap: 4,
    borderRadius: 36,
    position: 'absolute',
    top: 4,
    left: 4,
    zIndex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  subTagText: {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0,
    color: neutrals.white,
  },
  icon: {
    width: 8,
    height: 8,
  },
});
